import { useState } from "react";
import {
  CarrotCutting
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import { CardDetailsModal } from "@components/ui/CardDetailsModal";

const MotivationCardsView = ({ heading = ""}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);
  const handleOpen = ({
    label = null,
    icon = null,
    value = null,
    tabColor = null,
    model_value = null,
  }) => {
    setData({
      label,
      icon,
      value,
      tabColor,
      model_value,
    });
    setOpen(true);
  };
  const nutrientData = [
    {
      label: "Quote of the Day",
      key: "Sleep Schedule",
      icon: <CarrotCutting className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: "“Discipline is the bridge between goals and achievement.”",
      model_value: "A gentle reminder that consistency creates lasting success.",
    },
    {
      label: "Personalized Boost",
      key: "focus",
      icon: <CarrotCutting className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: "You’ve been active 4 days this week!",
      model_value: "Keep showing up — your momentum is building faster than you think.",
    },
    {
      label: "Wellness Tip",
      key: "awareness",
      icon: <CarrotCutting className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: "Take a short walk after meals.",
      model_value: "It helps digestion, improves focus, and boosts your energy naturally.",
    },
    {
      label: "Positive Affirmation",
      key: "gentle_return",
      icon: <CarrotCutting className="w-[28px] h-[28px]" />,
      tabColor: "#FFF0FB",
      value: "“I am progressing at my own pace, and that’s perfectly fine.”",
      model_value: "A moment to breathe, reset, and celebrate your growth."
    },
    {
      label: "Encouragement of the Day",
      key: "duration",
      icon: <CarrotCutting className="w-[28px] h-[28px]" />,
      tabColor: "#FFF0FF",
      value: "You’ve already done harder things — this is just another step.",
      model_value: "Stay strong, stay patient, and keep your purpose in sight."
    },
  ];

  const Card = ({ label, icon, value, tabColor, model_value }) => (
    <div
      //   key={index}
      className="py-4 px-4 md:py-5 md:px-6 rounded-[16px] bg-white border border-[#E6E6E6] flex flex-col gap-2"
      style={{
        boxShadow: "7px 7px 9.5px 0px #0000000D",
      }}
    >
      <div className="relative">
        <div
          className={`absolute border border-[#0575e6] -left-3 -top-1 rounded-full min-w-12 min-h-12 flex items-center justify-center border`}
          style={{
            backgroundColor: tabColor,
          }}
        >
          {icon}
        </div>
        <p className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-[14px] lg:text-[16px] font-[600] text-[#fff] py-2 px-8 md:px-10 rounded-full text-center lg:text-start min-w-[180px] md:min-w-[200px] max-w-full">
          {label}
        </p>
      </div>
      <div className="mt-2 md:mt-0">
        <p className="-[14px] lg:text-[16px] font-[600] text-[#606060] font-[Lato] leading-relaxed">
          {value}
        </p>
      </div>
            <div className="border-t border-t-[1px] border-dashed border-t-[#E7E7E7] pt-2">
        <p className="-[14px]  font-[400] text-[#898787] font-[Lato] leading-relaxed">
          {model_value}
        </p>
      </div>
    </div>
  );
  // Original layout (non-dashboard)
  return (
    <div className="p-6 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-lg ">
      <h1 className="text-center text-white mb-6">
        {heading}
      </h1>
      {/* First Row - 3 cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-3">
        {nutrientData
          .slice(0, 3)
          .map(({ label, icon, value, tabColor, model_value }, index) => (
            <Card
              key={index}
              label={label}
              icon={icon}
              value={value}
              tabColor={tabColor}
              model_value={model_value}
            />
          ))}
      </div>

      {/* Second Row - 2 cards centered */}
      <div className="flex justify-center w-full md:w-auto ">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full md:max-w-4xl">
          {nutrientData
            .slice(3)
            .map(({ label, icon, value, tabColor, model_value }, index) => (
              <Card
                key={index + 3}
                label={label}
                icon={icon}
                value={value}
                tabColor={tabColor}
                model_value={model_value}
              />
            ))}
        </div>
      </div>
      <CardDetailsModal open={open} setOpen={setOpen} data={data} />
    </div>
  );
};

export default MotivationCardsView;
